module.exports = __webpack_public_path__ + "media/images/project/mark-approval-13ccc855a1cb5b7ce2a046b7944eb524.svg";